<template>
    <div class="block-container">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>确认收货</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content-caption dashed">
            <span>单据信息</span>
        </div>
        <div class="simple-form flex col-3">
            <div class="form-group center" v-if="goodsShipVoucher.orderFlag">
                <div class="form-label">
                    <label>订单号</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ goodsShipVoucher.orderNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货单号</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ goodsShipVoucher.no }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货机构</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsShipVoucher.senderComName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货人</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsShipVoucher.senderContactName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货人联系方式</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsShipVoucher.senderContactTel}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>&nbsp;</label>
                </div>
                <div class="form-value width-1-5x">
                    <span></span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>司机姓名</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsShipVoucher.driverName || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>司机电话</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsShipVoucher.driverMobile || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>车辆牌号</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsShipVoucher.vehicleLsnNo || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>商品总费用(元)</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="goodsShipVoucher.amount != null">{{goodsShipVoucher.amount.toFixed(2) || '0.00'}}</span>
                    <span v-else>0.00</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>物流费用(元)</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsShipVoucher.logisFee || '0.00'}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>商品信息</span>
        </div>
        <div class="mb15">
            <span class="font-red">*温馨提示：1.如发货数量有误，可联系发货方调整数量。2.确认收货时，组装件自动入库。</span>
        </div>
        <div class="table-layout">
            <el-form>
                <el-table ref="multipleTable" :data="goodsShipItemList" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column align="center" label="资产信息" v-if="showAssetInfo">
                        <el-table-column align="left" width="130" prop="devcName" label="名称" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100" prop="devcCatName" label="分类" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100" prop="devcBrandName" label="品牌" show-overflow-tooltip></el-table-column>
                    </el-table-column>
                    <el-table-column align="center" label="商品信息" v-if="showAssetInfo">
                        <el-table-column align="left" width="130" prop="title" label="名称" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100" prop="catName" label="分类" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                    </el-table-column>
                    <el-table-column align="left" width="130" prop="title" label="名称" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                    <el-table-column align="left" width="100" prop="catName" label="分类" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                    <el-table-column align="left" width="100" prop="brandName" label="品牌" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                    <el-table-column align="center" width="160" label="需要供应商提供唯一标识码">
                        <template slot-scope="rows">
                            <span v-if="rows.row.vendorUknoFlag">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="60" prop="asmblAccFlag" label="组装件">
                        <template slot-scope="rows">
                            <span v-if="rows.row.asmblAccFlag">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="130" prop="price" label="价格(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.price != null">{{rows.row.price.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="60" prop="taxRate" label="税率(%)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.taxRate != null">{{rows.row.taxRate.toFixed(2) || 0.00}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="130" prop="ntxPrice" label="未税价(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.ntxPrice != null">{{rows.row.ntxPrice.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="130" prop="amount" label="费用小计(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.amount != null">{{rows.row.amount.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="80" prop="quantity" label="发货数量" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.quantity != null">{{scope.row.quantity - scope.row.offsetQuantity}}</span>
                            <span v-else>0</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="80" prop="surplusQuantity" label="待收货数量" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" width="80" prop="recvQuantity" label="收货数量" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item :prop="'goodsShipItemList.' + scope.$index + '.recvQuantity'">
                                <el-input class="text-right" type="text" @change="quantityChange(scope.row);" v-model="scope.row.recvQuantity"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" width="140" prop="batchNo" label="批次号" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item :prop="'goodsShipItemList.' + scope.$index + '.batchNo'">
                                <el-input type="text" v-model="scope.row.batchNo"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="rescDesc" label="描述" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item :prop="'goodsShipItemList.' + scope.$index + '.desc'">
                                <el-input type="textarea" v-model="scope.row.rescDesc"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
        </div>
        <div class="simple-form">
            <el-form :model="goodsRecvVoucher" :rules="validateRules" ref="arriveDate" class="demo-ruleForm">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">标题</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="title">
                            <el-input type="text" v-model="goodsRecvVoucher.title" placeholder="请输入标题"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="goodsRecvVoucher.exceptional">
                    <div class="form-label">
                        <label class="required">异常描述</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-input class="width-2x" type="textarea" v-model="goodsRecvVoucher.exceptionDesc" :rows="3" placeholder="请输入" :maxlength="120"></el-input>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>要求到货日期</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="dueArriveDate">
                            <el-select v-model="goodsRecvVoucher.dueArriveDate" placeholder="请选择">
                                <el-option v-for="(value, key) in desireArriveDate" :key="value" :label="value" :value="value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">实际到货日期</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="actualArriveDate">
                            <el-date-picker v-model="goodsRecvVoucher.actualArriveDate" :picker-options="pickerOptions0" type="date" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>
                <template v-if="autoInStock">
                    <div class="input-tip error">
                        <span>提示:确认收货后、将自动生成验收单</span>
                    </div>
                </template>
                <div class="input-tip error" v-if="!autoInStock">
                    <span>提示:未开启自动验收入库业务参数，确认收货后，需手动验收入库</span>
                </div>
                <div class="form-group center" v-if="autoInStock && showBizUnitWarehouse">
                    <div class="form-label">
                        <label class="required">入库仓库</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="warehouseId">
                            <el-select v-model="warehouseId">
                                <el-option v-for="item in warehouseList" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="autoInStock">
                    <div class="form-label">
                        <label>&nbsp;</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="autoReceive">
                            <el-checkbox v-model="autoReceive" @change="changeAutoReceive">机构负责人自动领用</el-checkbox>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </div>
        <swb-recv-file-edit :edit="true" ref="swb_recv_file_edit"></swb-recv-file-edit>

        <div class="content-caption dashed" v-if="goodsShipVoucher.shipVoucherFileList != null && goodsShipVoucher.shipVoucherFileList.length > 0">
            <span>发货附件</span>
        </div>
        <div class="file-view-list" v-if="goodsShipVoucher.shipVoucherFileList != null && goodsShipVoucher.shipVoucherFileList.length > 0">
            <div class="file-view-header">
                <div class="file-name">名称</div>
                <div class="file-opera">操作</div>
            </div>
            <template v-for="(fileInfo, index) in goodsShipVoucher.shipVoucherFileList">
                <swb-file-item-li :trackKey="index" :fileName="fileInfo.name" :fileBrowseUrl="fileInfo.fileBrowseUrl" :fileDownloadUrl="fileInfo.fileBrowseUrl" :fileUuid="fileInfo.fileUuid" :deletable="false"></swb-file-item-li>
            </template>
        </div>
        <div class="form-toolbar align-center" style="padding: 0;">
            <button class="swb-btn swb-btn-small" @click="saveGoodsRecvVoucher()">确认</button>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {getMerchantBizParam} from '../asset/assetMain'

    import goodsDelivApi from '../../api/goodsDeliv'
    import goodsOrderApi from '../../api/goodsOrder'
    import retailerApi from '../../api/retailer'
    import shopStockApi from '../../api/shopStock'
    //
    import SwbGoodsRecvVoucherList from './GoodsRecvVoucherList';
    Routes.add(SwbGoodsRecvVoucherList);

    import SwbGoodsRecvFileList from './GoodsRecvFileList';
    Vue.regist(SwbGoodsRecvFileList);

    export default {
        name: 'swb-goods-recv-voucher-sure',
        path: '/goods/recv/voucher/sure',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '确认收货',
        data: function () {
            // 校验
            let validateDueArriveDate = function (rule, value, callback) {
//                if(Utils.isNoB(value)) {
//                    callback(new Error('请选择要求到货日期'));
//                } else {
//                    callback();
//                }
                callback();
            };
            let validateTitle = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请输入标题'));
                } else {
                    if (value.length > 30) {
                        callback(new Error('标题最长不能超过30个字符'));
                    } else {
                        callback();
                    }
                }
            };
            let validateActualArriveDate = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请选择实际到货日期'));
                } else {
                    callback();
                }
            };
            return {
                goodsShipItemList: [],
                goodsRecvVoucher: {
                    arriveDelayed: false,
                    dueArriveDate: null,
                    actualArriveDate: new Date(),
                    exceptional: false,
                },
                goodsShipVoucher: {},
                flag: false,
                desireArriveDate: [],
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                // 校验
                validateRules: {
                    dueArriveDate: [{validator: validateDueArriveDate, trigger: 'blur'}],
                    actualArriveDate: [{validator: validateActualArriveDate, trigger: 'blur'}],
                    title: [{validator: validateTitle, trigger: 'blur'}]
                },
                autoInStock: false,
                autoReceive: false,
                principalId: null,
                warehouseId: null,
                warehouseList: [],
                exitSetupFlag: false,
                exitNotAsmblAcc: false,
                showBizUnitWarehouse: false,
                showAssetInfo: false
            }
        },
        created: function () {
            let goodsShipVoucherId = this.$route.query.id || null;
            //
            let self = this;
            getMerchantBizParam("show.biz.unit.warehouse", function (result) { // 显示门店/机构的仓库： {}
                self.showBizUnitWarehouse = Utils.isTrue(result);
            });
            getMerchantBizParam("display.asset.related.info.in.trading", function (result) {
                self.showAssetInfo = Utils.isTrue(result);
            });
            this.getGoodsShipVoucher(goodsShipVoucherId, function () {
                let goodsShipVoucher = self.goodsShipVoucher;
                getMerchantBizParam("auto.accept.asset.on.received", function (result) {
                    // 开启参数
                    self.autoInStock = Utils.isTrue(result);
                    //
                    self.getRetailerCom(goodsShipVoucher.buyerShopId);
                });
                self.getWarehouseList(goodsShipVoucher.buyerBizUnitId);
            });
        },
        methods: {
            getWarehouseList(recvBizUnitId){
                let self = this;
                let postData = {};
                if (!Utils.isNoB(recvBizUnitId)) {
                    postData.filterItems = {
                        retailerShopId: recvBizUnitId
                    };
                }
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    if (result.type == 'info') {
                        let warehouseList = result.data;
                        warehouseList.forEach(function (item) {
                            if (item.defaulted) {
                                self.warehouseId = item.id;
                            }
                        });
                        self.warehouseList = warehouseList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getRetailerCom(comId){
                let self = this;
                retailerApi.getRetailerCom({
                    comId: comId
                }, function (result) {
                    if (result.type == 'info') {
                        self.principalId = result.data.principalId;
                        //
                        if (self.autoInStock && !Utils.isNoB(self.principalId)) {
                            self.autoReceive = true;
                        }
                    }
                });
            },
            changeAutoReceive: function () {
                if (Utils.isNoB(this.principalId)) {
                    this.autoReceive = false;
                    MsgBox.warning("请先设置机构责任人");
                }
            },
            getGoodsShipVoucher: function (goodsShipVoucherId, callback) {
                let self = this;
                let postData = {};
                postData.id = goodsShipVoucherId;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsShipVoucherInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == "info") {
                        self.goodsShipVoucher = result.data;
                        let exitSetupFlag = false;
                        let exitNotAsmblAcc = false;
                        if (self.goodsShipVoucher != null) {
                            let itemList = result.data.itemList;
                            if (itemList != null && itemList.length > 0) {

                                for (let i = 0; i < itemList.length; i++) {
                                    let item = itemList[i];
                                    item.recvVoucherItemQuantity = item.surplusQuantity;
                                    item.recvQuantity = item.surplusQuantity;
                                    // 默认批次号
                                    item.batchNo = new Date().format('yyyyMMddHHmm');
                                    if (item.setupFlag) {
                                        exitSetupFlag = true;
                                    }
                                    if (!item.asmblAccFlag) {
                                        exitNotAsmblAcc = true;
                                    }
                                }
                            }
                            self.goodsShipItemList = Utils.merge([], itemList);
                            self.exitSetupFlag = exitSetupFlag;
                            self.exitNotAsmblAcc = exitNotAsmblAcc;
                        }
                        self.getDesireArriveDate();
                    } else {
                        MsgBox.warning(result.message);
                    }
                    callback();
                })
            },
            getDesireArriveDate: function () {
                let self = this;
                let postData = {};
                postData.orderId = self.goodsShipVoucher.orderId;
                postData.formId = self.goodsShipVoucher.allocFormId;
                postData.buyerShopId = self.goodsShipVoucher.buyerShopId;
                goodsOrderApi.getDistinctOrderGoodsAllocItemDesireArriveDateList(postData, function (result) {
                    if (result.type == "info") {
                        self.desireArriveDate = result.data;
                        //
                        self.goodsRecvVoucher.dueArriveDate = self.desireArriveDate[0] || null;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            quantityChange: function (row) {
                let self = this;
                if (!Utils.isNaturalStr(row.recvQuantity, true)) {
                    row.recvQuantity = null;
                    row.amount = 0;
                    MsgBox.warning('必须为大于0的整数!');
                } else {
                    if (parseInt(row.recvQuantity) > parseInt(row.surplusQuantity)) {
                        row.recvQuantity = null;
                        row.amount = 0;
                        MsgBox.warning("收货数量不能大于发货数量！");
                    }
                    row.amount = parseFloat((parseInt(row.recvQuantity || 0) * parseFloat(row.price || 0)).toFixed(2));
                    //
                    let goodsShipItemList = self.goodsShipItemList || [];
                    for (let i = 0; i < goodsShipItemList.length; i++) {
                        let goodsShipItem = goodsShipItemList[i];
                        if (!Utils.isNoB(goodsShipItem.recvQuantity)) {
                            if (parseInt(goodsShipItem.recvQuantity) < parseInt(goodsShipItem.surplusQuantity)) {
                                let goodsRecvVoucher = self.goodsRecvVoucher || {};
                                goodsRecvVoucher.exceptional = true;
                                self.goodsRecvVoucher = Utils.merge({}, goodsRecvVoucher);
                                break;
                            } else {
                                let goodsRecvVoucher = self.goodsRecvVoucher || {};
                                goodsRecvVoucher.exceptional = false;
                                goodsRecvVoucher.exceptionDesc = "";
                                self.goodsRecvVoucher = Utils.merge({}, goodsRecvVoucher);
                            }
                        }
                    }
                }
                // 计算商品总费用
                let amount = 0;
                for (let i = 0; i < self.goodsShipItemList.length; i++) {
                    let goodsShipItem = self.goodsShipItemList[i];
                    amount += parseFloat(goodsShipItem.amount || 0);
                }
                self.goodsShipVoucher.amount = amount;
            },
            saveGoodsRecvVoucher: function () {
                if (!Utils.repeatChecker.isValidFor("saveGoodsRecvVoucher", 1000)) {
                    return;
                }
                let self = this;
                //
                if (Utils.isNoB(self.goodsRecvVoucher.title)) {
                    MsgBox.warning("请输入标题！");
                    return;
                }
                if (Utils.isTrue(self.goodsRecvVoucher.exceptional)) {
                    if (Utils.isNoB(self.goodsRecvVoucher.exceptionDesc)) {
                        MsgBox.warning("请输入异常描述！");
                        return;
                    }
                }
                //
                let boxFlag = false;
                let goodsRecvVoucherItemList = [];
                let goodsShipVoucher = self.goodsShipVoucher;
                if (goodsShipVoucher != null) {
                    self.goodsRecvVoucher.shipVoucherId = goodsShipVoucher.id;
                    self.goodsRecvVoucher.allocFormId = goodsShipVoucher.allocFormId;
                    self.goodsRecvVoucher.allocFormTitle = goodsShipVoucher.allocFormTitle;
                    self.goodsRecvVoucher.buyerShopId = goodsShipVoucher.buyerShopId;
                    self.goodsRecvVoucher.buyerShopName = goodsShipVoucher.buyerShopName;
                    self.goodsRecvVoucher.buyerRecvRegionId = goodsShipVoucher.buyerRecvRegionId;
                    self.goodsRecvVoucher.buyerRecvRegionName = goodsShipVoucher.buyerRecvRegionName;
                    self.goodsRecvVoucher.buyerRecvStreet = goodsShipVoucher.buyerRecvStreet;
                    self.goodsRecvVoucher.buyerRecvAddr = goodsShipVoucher.buyerRecvAddr;
                    self.goodsRecvVoucher.buyerRecvContactTel = goodsShipVoucher.buyerRecvContactTel;
                    self.goodsRecvVoucher.orderId = goodsShipVoucher.orderId;
                    self.goodsRecvVoucher.sellerId = goodsShipVoucher.sellerId;
                    self.goodsRecvVoucher.sellerType = goodsShipVoucher.sellerType;
                    self.goodsRecvVoucher.sellerVendorType = goodsShipVoucher.sellerVendorType;
                    self.goodsRecvVoucher.sellerName = goodsShipVoucher.sellerName;
                    self.goodsRecvVoucher.sellerComId = goodsShipVoucher.sellerComId;
                    self.goodsRecvVoucher.sellerComName = goodsShipVoucher.sellerComName;
                    self.goodsRecvVoucher.sellerRealComId = goodsShipVoucher.sellerRealComId;
                    self.goodsRecvVoucher.sellerRealComCode = goodsShipVoucher.sellerRealComCode;
                    self.goodsRecvVoucher.buyerId = goodsShipVoucher.buyerId;
                    self.goodsRecvVoucher.buyerType = goodsShipVoucher.buyerType;
                    self.goodsRecvVoucher.buyerName = goodsShipVoucher.buyerName;
                    self.goodsRecvVoucher.buyerComId = goodsShipVoucher.buyerComId;
                    self.goodsRecvVoucher.buyerComName = goodsShipVoucher.buyerComName;
                    self.goodsRecvVoucher.buyerRealComId = goodsShipVoucher.buyerRealComId;
                    self.goodsRecvVoucher.buyerRealComCode = goodsShipVoucher.buyerRealComCode;
                    self.goodsRecvVoucher.deliverType = goodsShipVoucher.deliverType;
                    self.goodsRecvVoucher.ioFlag = goodsShipVoucher.ioFlag;
                    self.goodsRecvVoucher.amount = goodsShipVoucher.amount;
//                    if(self.goodsRecvVoucher.dueArriveDate == null) {
//                        MsgBox.warning("请选择要求到货日期！");
//                        return false;
//                    }
                    if (self.goodsRecvVoucher.actualArriveDate) {
                        self.goodsRecvVoucher.actualArriveDate = self.goodsRecvVoucher.actualArriveDate.format('yyyy-MM-dd');
                    } else {
                        MsgBox.warning("请选择实际到货日期！");
                        return false;
                    }
                    //
                    let fileList = self.$refs.swb_recv_file_edit.getDlgResult().data;
                    console.log(fileList);
                    self.goodsRecvVoucher.fileList = fileList;
                    //
                    let list = goodsShipVoucher.itemList;
                    let goodsShipItemList = self.goodsShipItemList;
                    if (goodsShipItemList != null && goodsShipItemList.length > 0) {
                        for (let j = 0; j < goodsShipItemList.length; j++) {
                            let goodsRecvVoucherItem = {};
                            if (list != null && list.length > 0) {
                                for (let i = 0; i < list.length; i++) {
                                    if (goodsShipItemList[j].skuId == list[i].skuId) {
                                        goodsRecvVoucherItem.shipVoucherItemId = list[i].id;
                                        goodsRecvVoucherItem.orderItemId = list[i].orderItemId;
                                        goodsRecvVoucherItem.skuId = list[i].skuId;
                                        goodsRecvVoucherItem.goodsId = list[i].goodsId;
                                        goodsRecvVoucherItem.srcVendorId = list[i].srcVendorId;
                                        goodsRecvVoucherItem.svcNo = list[i].svcNo;
                                        goodsRecvVoucherItem.title = list[i].title;
                                        goodsRecvVoucherItem.catId = list[i].catId;
                                        goodsRecvVoucherItem.catName = list[i].catName;
                                        goodsRecvVoucherItem.brandId = list[i].brandId;
                                        goodsRecvVoucherItem.brandName = list[i].brandName;
                                        goodsRecvVoucherItem.unit = list[i].unit;
                                        goodsRecvVoucherItem.wrntPeriod = list[i].wrntPeriod;
                                        goodsRecvVoucherItem.batchNo = list[i].batchNo || '';
                                        //
                                        goodsRecvVoucherItem.devcName = list[i].devcName;
                                        goodsRecvVoucherItem.devcCatId = list[i].devcCatId;
                                        goodsRecvVoucherItem.devcCatName = list[i].devcCatName;
                                        goodsRecvVoucherItem.devcBrandId = list[i].devcBrandId;
                                        goodsRecvVoucherItem.devcBrandName = list[i].devcBrandName;
                                        goodsRecvVoucherItem.devcModel = list[i].devcModel;
                                        goodsRecvVoucherItem.devcFixedSpec = list[i].devcFixedSpec;
                                        goodsRecvVoucherItem.devcUnit = list[i].devcUnit;
                                        //
                                        goodsRecvVoucherItem.vendorUknoFlag = goodsShipItemList[j].vendorUknoFlag;
                                        goodsRecvVoucherItem.setupFlag = goodsShipItemList[j].setupFlag;
                                        goodsRecvVoucherItem.asmblFlag = goodsShipItemList[j].asmblFlag;
                                        goodsRecvVoucherItem.asmblAccFlag = goodsShipItemList[j].asmblAccFlag;
                                        goodsRecvVoucherItem.asmblWhileSetup = goodsShipItemList[j].asmblWhileSetup;
                                        goodsRecvVoucherItem.price = goodsShipItemList[j].price;
                                        goodsRecvVoucherItem.ntxPrice = goodsShipItemList[j].ntxPrice;
                                        goodsRecvVoucherItem.amount = goodsShipItemList[j].amount;
                                        //
                                        if (!self.flag) {
                                            if (goodsShipItemList[j].recvQuantity > goodsShipItemList[j].surplusQuantity) {
                                                if (!boxFlag) {
                                                    MsgBox.warning("填写数量有误");
                                                    boxFlag = true;
                                                    break;
                                                }
                                            } else if (goodsShipItemList[j].recvQuantity > 0) {
                                                self.flag = true;
                                            }
                                        }
                                        goodsRecvVoucherItem.quantity = goodsShipItemList[j].recvQuantity;
                                        goodsRecvVoucherItem.desc = goodsShipItemList[j].rescDesc;
                                    }
                                }
                            }
                            goodsRecvVoucherItemList.push(goodsRecvVoucherItem);
                        }
                    }
                    self.goodsRecvVoucher.goodsRecvVoucherItemList = goodsRecvVoucherItemList;
                }
                if (self.flag) {
                    let postData = Utils.merge({}, self.goodsRecvVoucher);
                    postData.autoInStock = self.autoInStock;
                    postData.warehouseId = self.warehouseId;
                    self.warehouseList.forEach(function (warehouse) {
                        if (warehouse.id == self.warehouseId) {
                            postData.warehouseName = warehouse.name;
                        }
                    });
                    if (self.autoInStock) {
                        postData.autoReceive = self.autoReceive;
                    }
                    //
                    let msgBoxDlg = MsgBox.loading();
                    goodsDelivApi.saveGoodsRecvVoucher(postData, function (result) {
                        msgBoxDlg.close();
                        if (result.type == "info") {
                            MsgBox.success(result.message);
                            self.$router.push({
                                path: SwbGoodsRecvVoucherList.path
                            });
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else if (!boxFlag) {
                    MsgBox.warning("至少确认收货一个");
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsRecvVoucherSure.vue